var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import color from "detail/utils/color";
import ButtonComponent from "../../../../comments/button";
import Api2 from '../../../../utils/api2';
import FlexComponent from "detail/comments/flex";
import GalleryShoppingItemView from "../../../layer/galleryShoppingItemView";
var VideoComponent = function (_a) {
    var item_id = _a.item_id, flagVI = _a.flagVI, setFlagVI = _a.setFlagVI;
    var _b = useState([]), data = _b[0], setData = _b[1];
    var _c = useState(0), totalCount = _c[0], setTotalCount = _c[1];
    var _d = useState(1), lastPage = _d[0], setLastPage = _d[1];
    var _e = useState(1), currentPage = _e[0], setCurrent = _e[1];
    var _f = useState(null), selectedVideoGroup = _f[0], setSelectedVideoGroup = _f[1];
    var _g = useState(0), selectedReviewId = _g[0], setSelectedReviewId = _g[1];
    var _h = useState(0), selectedFileSortNum = _h[0], setSelectedFileSortNum = _h[1];
    var getVideoList = function (page) {
        if (page === void 0) { page = 1; }
        Api2.getGalleryShoppingVideos(item_id, page).then(function (res) {
            if (res) {
                if (page === 1) {
                    setData(res.data.videos);
                }
                else {
                    setData(function (prev) { return __spreadArray(__spreadArray([], prev, true), res.data.videos, true); });
                    setCurrent(function (prev) { return prev + 1; });
                }
                setTotalCount(res.data.videosCount);
                setLastPage(res.data.lastPage);
            }
        });
    };
    var handleVideoItemClick = function (e, review_id, groupNumber, fileSortNum) {
        setSelectedVideoGroup(function (prevGroup) {
            return (prevGroup === groupNumber ? prevGroup : groupNumber);
        });
        setFlagVI('video');
        setSelectedReviewId(review_id);
        setSelectedFileSortNum(fileSortNum);
        //레이어 상단으로이동하려고함..
        // setTimeout(() => {
        //     onUpHandler(`reviewGalleryVideoItemLayer${groupNumber}`);
        // }, 1);
    };
    var onClickMore = function () {
        getVideoList(currentPage + 1); //동영상정보
    };
    useEffect(function () {
        getVideoList(); //동영상정보
    }, []);
    return (React.createElement(Wrap, null, (data === null || data === void 0 ? void 0 : data.length) > 0 &&
        React.createElement("div", { className: 'section-video' },
            React.createElement("div", { className: 'title' },
                React.createElement("span", { className: 'fs-14 fw-700 c-333' },
                    "\uB3D9\uC601\uC0C1",
                    totalCount,
                    "\uAC74")),
            React.createElement("div", { className: 'image-box' }, data.map(function (v, i) {
                var _a, _b, _c;
                var review_id = v === null || v === void 0 ? void 0 : v.id; //리뷰 id
                var fileSortNum = (_a = v === null || v === void 0 ? void 0 : v.file) === null || _a === void 0 ? void 0 : _a.id; //파일 순서
                var fileThumbUrl = (_b = v === null || v === void 0 ? void 0 : v.file) === null || _b === void 0 ? void 0 : _b.videoThumbnailUrl; //파일 주소
                var fileName = (_c = v === null || v === void 0 ? void 0 : v.file) === null || _c === void 0 ? void 0 : _c.fileThumbName; //파일 이름
                var count = i + 1;
                var groupNumber = Math.floor(i / 5) + 1;
                return (React.createElement(React.Fragment, { key: i },
                    React.createElement("div", { className: "image-item reviewGalleryVideoGroup".concat(groupNumber), style: { margin: count % 5 !== 0 ? '0 4px 4px 0' : undefined }, onClick: function (e) { return handleVideoItemClick(e, review_id, groupNumber, fileSortNum); } },
                        React.createElement("img", { className: 'hoverPointer', src: "".concat(fileThumbUrl, "?time=").concat(new Date().getTime()), alt: fileName, onError: function (e) {
                                e.currentTarget.src = "".concat(process.env.REACT_APP_CDN_IMG, "/img_shopping/img_goods/img_no/no_item_img.jpg");
                            } }),
                        React.createElement(ButtonComponent, { type: 'video', className: 'video-middle', onClick: function (e) { return handleVideoItemClick(e, review_id, groupNumber, fileSortNum); } })),
                    ((i + 1) % 5 === 0 || (i + 1) === data.length) && flagVI === 'video' && selectedVideoGroup === groupNumber && (React.createElement("div", { className: "reviewGalleryVideoItemLayer".concat(groupNumber) },
                        React.createElement(GalleryShoppingItemView, { item_id: item_id, review_id: selectedReviewId, fileSortNum: selectedFileSortNum, layerClose: handleVideoItemClick })))));
            })),
            currentPage !== lastPage &&
                React.createElement("div", { className: 'more-view' },
                    React.createElement(FlexComponent, { type: 'default', className: 'more-view hoverPointer', onClick: onClickMore },
                        React.createElement(ButtonComponent, { type: 'moreView' }, "\uB354 \uBCF4\uAE30"),
                        React.createElement("span", { className: 'plr-1' }),
                        React.createElement("span", null,
                            React.createElement("i", { className: 'icon-angle-down' })))))));
};
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding:18px 0 0 0;\n    i{\n        font-size:14px;\n        font-weight:bold;\n    }\n    .image-box{\n        padding:0 0 18px 0;\n    }\n    .image-item{\n        border:1px solid ", ";\n    }\n    .image-item:hover{\n        border:1px solid ", ";\n    }\n    .more-view{\n        color:", ";\n        display:inline-block;\n    }\n    .more-view:hover{\n        color:", " !important;\n        button{\n            color:", " !important;\n        }\n    }\n"], ["\n    padding:18px 0 0 0;\n    i{\n        font-size:14px;\n        font-weight:bold;\n    }\n    .image-box{\n        padding:0 0 18px 0;\n    }\n    .image-item{\n        border:1px solid ", ";\n    }\n    .image-item:hover{\n        border:1px solid ", ";\n    }\n    .more-view{\n        color:", ";\n        display:inline-block;\n    }\n    .more-view:hover{\n        color:", " !important;\n        button{\n            color:", " !important;\n        }\n    }\n"])), color.colorE5, color.color418, color.color418, color.color333, color.color333);
export default React.memo(VideoComponent);
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/review/gallery/shopping/VideoComponent.tsx
// module id = 312
// module chunks = 0